import React from "react";
import { Button as MuiButton, Box, TextField, Typography } from "@mui/material";
import { styled } from "@mui/system";
import MenuItem from "@mui/material/MenuItem";
import { LuRefreshCcw } from "react-icons/lu";

const DateContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "20px",
  backgroundColor: "#0c0513",
  color: "#c770f0",
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  margin: "0 10px",
  "& .MuiInputBase-input": {
    color: "#fff",
  },
  "& .MuiInputLabel-root": {
    color: "#c770f0",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#c770f0",
    },
    "&:hover fieldset": {
      borderColor: "#c770f0",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#c770f0",
    },
  },
}));
const EditButton = styled(MuiButton)`
  backgroundcolor: #623686 !important;
  color: white !important;
  &:hover: {
    backgroundcolor: #6d20c5d7;
  }
  font-size: 1rem;
  border-radius: 5px;
  color: #fff;
  margin-left: 1rem;
  @media (max-width: 600px) {
    font-size: 0.9rem; /* Adjust font size for mobile screens */
    padding: 0.3rem; /* Reduce padding for better mobile fit */
  }
`;
const RefreshButton = styled(Typography)`
  color: white !important;
  &:hover: {
    backgroundcolor: #6d20c5d7;
  }
  margin: 0;
  font-size: 1rem;
  border-radius: 5px;
  padding: 0.5rem;
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
  color: #fff;
  margin-left: 1rem;
  @media (max-width: 600px) {
    font-size: 1.2rem; /* Adjust font size for mobile screens */ /* Reduce padding for better mobile fit */
  }
`;

const SelectTodo = ({ edit, setEdit, refresh, setItem }) => {
  const handleOnclick = () => {
    setEdit(!edit);
  };

  return (
    <DateContainer>
      <StyledTextField
        style={{ width: "90%" }}
        select
        variant="outlined"
        label="Select"
        size="small"
        name="select"
        defaultValue={"notDone"}
        onChange={(e) => {
          setItem(e.target.value);
        }}
      >
        <MenuItem key="done" value="done">
          Completed
        </MenuItem>
        <MenuItem key="notDone" value="notDone">
          In Progress
        </MenuItem>
        <MenuItem key="both" value="both">
          All List
        </MenuItem>
      </StyledTextField>
      <EditButton
        style={{ backgroundColor: "#623686" }}
        onClick={handleOnclick}
      >
        {edit ? "Done" : "Edit"}
      </EditButton>
      <RefreshButton style={{ backgroundColor: "#623686" }} onClick={refresh}>
        <LuRefreshCcw />
      </RefreshButton>
    </DateContainer>
  );
};

export default SelectTodo;
